

import React, { useState, useEffect } from "react";
import {
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
  Label,
} from "reactstrap";
import { DownDropArrow } from "../../../assets/images";
import DatePicker from "react-datepicker";
import moment from "moment";
import { CalenderIcon } from "../../Icon";
import "./CommonDateSelect.scss";
import {
  getCurrentFinancialYear,
  previousFinancialYear,
} from "../../../utils/commonFunctions";

type AppProps = {
  toggle: boolean;
  setToggle: (data: boolean) => void;
  startDate: string;
  endDate: string;
  handleStartDateChange: (date: string) => void;
  handleEndDateChange: (date: string) => void;
  setStartDate?: any;
  setEndDate?: any;
};

const CommonMonthSelect = ({
  toggle,
  setToggle,
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  setStartDate,
  setEndDate,
}: AppProps) => {
  const currentFY = getCurrentFinancialYear();
  const previousFY = previousFinancialYear();
  const [text, setText] = useState("Current Financial Year");
  const [chooseMonth, setChooseMonth] = useState<string | null>(null);

  useEffect(() => {
    handleStartDateChange(`${currentFY?.split("-")[0]}-04-01`);
    handleEndDateChange(`${currentFY?.split("-")[1]}-03-31`);
   
  }, []);

  const handleCurrentYear = () => {
    setText("Current Financial Year");
    handleStartDateChange(`${currentFY?.split("-")[0]}-04-01`);
    handleEndDateChange(`${currentFY?.split("-")[1]}-03-31`);
    setToggle(!toggle);
    setChooseMonth(null); 
  };

  const handlePreviousYear = () => {
    setText("Previous Financial Year");
    handleStartDateChange(`${previousFY?.split("-")[0]}-04-01`);
    handleEndDateChange(`${previousFY?.split("-")[1]}-03-31`);
    setToggle(!toggle);
    setChooseMonth(null); 
  };

  const handleMonthChange = (date: Date | null) => {
    if (date) {
      const formattedMonth = moment(date).format("YYYY-MM");
      setChooseMonth(formattedMonth);
      setText(moment(date).format("MMMM YYYY"));
      
      const startOfMonth = moment(date).startOf("month").format("YYYY-MM-DD");
      const endOfMonth = moment(date).endOf("month").format("YYYY-MM-DD");

      handleStartDateChange(startOfMonth);
      handleEndDateChange(endOfMonth);
    }
    setToggle(!toggle);
  };

  return (
    <ButtonDropdown isOpen={toggle} toggle={() => setToggle(!toggle)}>
      <DropdownToggle
        caret
        color="#262a44"
        style={{
          border: "1px solid #bfcbe1",
          backgroundColor: "#ffffff",
          height: "38px",
        }}
      >
        <span
          style={{
            color: "#262a44",
            fontSize: "16px",
          }}
        >
          {text}
        </span>{" "}
        <img src={DownDropArrow} alt="" />
      </DropdownToggle>
      <DropdownMenu
        style={{
          width: "350px",
          padding: "31px 25px 30px",
          position: "absolute",
        }}
      >
        <div className="form-group">
          <div className="date-picker-wraper mr-0">
            <Label className="m-0 p-0 w-100">
              <DatePicker
                dateFormat="MMM yyyy"
                selected={chooseMonth ? new Date(`${chooseMonth}-01`) : null}
                onChange={(date: Date | null) => handleMonthChange(date)}
                showMonthYearPicker
                placeholderText="Select Month"
                className="form-control"
              />
              <span
                className="calender-icon-style"
                style={{ top: "47px", right: "50px", cursor: "pointer" }}
              >
                <CalenderIcon />
              </span>
            </Label>
          </div>
        </div>
        <button
          className="btn btn-outline-secondary col-md-12 mb-2"
          onClick={() => handleCurrentYear()}
          style={{
            color: text === "Current Financial Year" ? "red" : "",
            borderColor: text === "Current Financial Year" ? "red" : "",
          }}
        >
          Current FY
        </button>
        <button
          className="btn btn-outline-secondary col-md-12"
          onClick={() => handlePreviousYear()}
          style={{
            color: text === "Previous Financial Year" ? "red" : "",
            borderColor: text === "Previous Financial Year" ? "red" : "",
          }}
        >
          Previous FY
        </button>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default CommonMonthSelect;


